import * as C from 'actions/constants';

export const blankState = {
  list: [],
  map: [],
  mapAll: [],
  meta: {},
  feedback: {},
  loading: false,
};

const FeedbackReducer = (state = blankState, action) => {
  switch (action.type) {
    case C.LOAD_FEEDBACK:
    case C.LOAD_FEEDBACKS:
    case C.LOAD_FEEDBACKS_MAP:
    case C.LOAD_ALL_FEEDBACKS_MAP:
    case C.LOAD_FEEDBACKS_PHOTOS: {
      return { ...state, loading: true };
    }
    case C.LOAD_FEEDBACK_SUCCESS: {
      const { data } = action;
      return { ...state, loading: false, feedback: data };
    }
    case C.LOAD_FEEDBACKS_SUCCESS: {
      const { data, meta } = action;
      return {
        ...state,
        list: data,
        meta,
        loading: false,
      };
    }
    case C.LOAD_FEEDBACKS_MAP_SUCCESS: {
      const { data, meta } = action;
      return {
        ...state,
        map: data,
        meta,
        loading: false,
      };
    }
    case C.LOAD_ALL_FEEDBACKS_MAP_SUCCESS: {
      const { data } = action;
      return {
        ...state,
        mapAll: data,
        loading: false,
      };
    }
    case C.LOAD_FEEDBACKS_PHOTOS_SUCCESS: {
      const { data, meta, page } = action;
      const oldState = (page === 1) ? [] : state.photoFeedbacks;
      return {
        ...state,
        photoFeedbacks: oldState.concat(data),
        photoPage: page,
        meta,
        loading: false,
      };
    }
    case C.LOAD_FEEDBACK_ERROR:
    case C.LOAD_FEEDBACKS_ERROR:
    case C.LOAD_FEEDBACKS_MAP_ERROR:
    case C.LOAD_ALL_FEEDBACKS_MAP_ERROR:
    case C.LOAD_FEEDBACKS_PHOTOS_ERROR: {
      return { ...state, loading: false };
    }
    case C.CLOSE_REPORT: {
      return blankState;
    }
    default:
      return state;
  }
};

export default FeedbackReducer;
